import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { LocationStrategy, PathLocationStrategy } from "@angular/common";
import { AppRoutes } from "./app.routing";
import { AppComponent } from "./app.component";

import { FlexLayoutModule } from "@angular/flex-layout";
import { FullComponent } from "./layouts/full/full.component";
import { AppHeaderComponent } from "./layouts/full/header/header.component";
import { AppSidebarComponent } from "./layouts/full/sidebar/sidebar.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { DemoMaterialModule } from "./demo-material-module";

import { SharedModule } from "./shared/shared.module";
import { SpinnerComponent } from "./shared/spinner.component";
import { GizLayoutModule } from "./giz-layout/giz-layout.module";
import {
  NgcCookieConsentConfig,
  NgcCookieConsentModule,
} from "ngx-cookieconsent";

const cookieConfig: NgcCookieConsentConfig = {
  cookie: {
    //domain: "localhost",
    domain: "wikipapa.org",
    secure: true,
  },
  palette: {
    popup: {
      background: "#e1c7e5",
      text: "#605960",
    },
    button: {
      background: "#fff",
    },
  },
  theme: "classic",
  type: "opt-out",

  elements: {
    messagelink: `
    <span id="cookieconsent:desc" class="cc-message" style=" font-family:'Raleway'; font-size: 9pt;">{{message}} 
      <a aria-label="learn more about cookies" tabindex="0" class="cc-link" href="{{cookiePolicyHref}}" target="_blank" rel="noopener noreferrer">{{cookiePolicyLink}}</a>
    </span>
    `,
  },

  content: {
    message:
      "Esta página utiliza cookies y otras tecnologías para que podamos mejorar su experiencia en nuestros sitios:",

    cookiePolicyLink: "Más información.",
    cookiePolicyHref: "/policy-a",

    allow: "Acepto",
    deny: "Rechazo",
  },
};
@NgModule({
  declarations: [
    AppComponent,
    FullComponent,
    AppHeaderComponent,
    SpinnerComponent,
    AppSidebarComponent,
  ],
  imports: [
    NgcCookieConsentModule.forRoot(cookieConfig),
    BrowserModule,
    BrowserAnimationsModule,
    DemoMaterialModule,
    FormsModule,
    FlexLayoutModule,
    HttpClientModule,
    SharedModule,
    GizLayoutModule,
    RouterModule.forRoot(AppRoutes),
  ],
  providers: [
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
